import ScrollBooster from 'scrollbooster';

export default function () {
  document.addEventListener('DOMContentLoaded', function(event) {
    const caution = document.getElementById('caution');
    const targetButton = document.getElementById('submit');
    const triggerCheckbox = document.querySelector('input[name="agree"]');
    const check = document.getElementById('chkbox');
    caution.addEventListener('click', function(){ triggerCheckbox.click(); });

    triggerCheckbox.addEventListener('change', function() {
      if (this.checked) {
        check.classList.add('is-active');
        if(inputCheck()){
          targetButton.disabled = false;
          targetButton.classList.remove('is-inactive');
          targetButton.classList.add('is-active');
        }
      } else {
        targetButton.disabled = true;
        targetButton.classList.remove('is-active');
        targetButton.classList.add('is-inactive');
        check.classList.remove('is-active');
      }
    }, false);
  }, false);

  const mail = document.getElementById('email');
  mail.addEventListener('input', function(e) {
    const submit = document.getElementById('submit');
    if(inputCheck()){
      submit.disabled = false;
      submit.classList.remove('is-inactive');
      submit.classList.add('is-active');
    } else {
      submit.disabled = true;
      submit.classList.add('is-inactive');
      submit.classList.remove('is-active');
    }
  });

  const scrollElm = document.getElementById('scroll-trigger');
  const check = document.getElementById('chk-trigger');
  const emailInput = document.getElementById('email-input');
  scrollElm.addEventListener('scroll', function() {
    var tolerance = 2;
    if (Math.floor(scrollElm.scrollHeight) - Math.floor(scrollElm.scrollTop) <= Math.floor(scrollElm.clientHeight) + tolerance) {
      check.classList.remove('is-inactive');
      emailInput.removeAttribute('disabled');
    }
  });
}

const inputCheck = () => {
  const mail = document.getElementById('email-input');
  const agree = document.querySelector('input[name="agree"]');
  if( mail.value !== "" && agree.checked ){
    return true;
  } else {
    return false;
  }
}
